import { Lock } from 'lucide-react';

/**
 * Renders an INR amount with a strict separation between:
 *  - "masked by role" (backend sets amounts_masked=true) → padlock badge
 *  - "no value entered yet" (backend returns amount=null and masked=false) → em-dash
 * Owner/Accounts/Commercials must NEVER see the padlock — they always have visibility.
 */
export const MaskedAmount = ({ amount, masked, className = '' }) => {
  if (masked) {
    return (
      <span data-testid="masked-amount-indicator" className={`masked-amount ${className}`}>
        <Lock size={11} strokeWidth={2.2} />
        <span>₹ •••••</span>
      </span>
    );
  }
  if (amount == null || amount === '') {
    return (
      <span data-testid="empty-amount-indicator"
            className={`font-mono tabular-nums text-[13px] text-[hsl(var(--foreground-subtle))] ${className}`}>
        —
      </span>
    );
  }
  return (
    <span className={`font-mono tabular-nums text-[13px] ${className}`}>
      {new Intl.NumberFormat('en-IN', { style: 'currency', currency: 'INR', maximumFractionDigits: 0 }).format(amount)}
    </span>
  );
};
